import { qrySelfChainsApi, myShareJielongActListApi, jieLongOrderStatApi, exportJieLongOrderApi, qrySalesAndOrgChainsApi, specificStaffApi } from "@/libs/api.js";
import { uleUrl, uleCdn, getCookie } from "@/libs/common";
import bottomPop from "@/components/ylsq/bottomPop.vue";
import shareButton from "@/components/ylsq/shareButton.vue";
import countDown from "@/components/ylsq/countDown.vue";
export default {
  name: "group",
  components: {
    bottomPop,
    shareButton,
    countDown,
  },
  data() {
    return {
      isShowBottom: false,
      myQuery: {
        orgId: "",
        pageIndex: 1,
        pageSize: 5,
        clientCallType: "H5",
      },
      myList: [],
      myListStatus: 0, // 列表状态 0-初始 1-有数据 2-无数据
      myListFinished: false,
      myListSurplus: 0, // 剩余个数
      helpQuery: {
        orgId: "",
        pageIndex: 1,
        pageSize: 10,
        clientCallType: "H5",
        keyword: "",
      },
      helpLoading: false,
      helpFinished: false,
      helpFinishedText: "加载中...",
      helpIsLoad: false,
      helpList: [],
      helpListStatus: 0, // 列表状态 0-初始 1-有数据 2-无数据
      shareQuery: {
        startIndex: 1,
        pageSize: 100,
        clientCallType: "H5",
      },
      shareLoading: false,
      shareFinished: false,
      shareFinishedText: "加载中...",
      shareIsLoad: false,
      shareList: [],
      shareListStatus: 0, // 列表状态 0-初始 1-有数据 2-无数据
      orderDataList: {},
      orgId: "",
      currentId: null, // 当前活动id
      currentState: 0, // 当前活动状态
      tabActive: 1,
      navList: [
        {
          name: "拼团接龙",
          id: 1,
        },
        {
          name: "已分享",
          id: 2,
        },
      ],
      isWhiteBySH: false,
      // showMy: false,
      canShow: false,
    };
  },

  mounted() {
    console.log(this.$browser().ios);
    console.log(this.$browser());
    if (this.$browser().ios) {
      if (this.$browser().version >= 305) {
        this.canShow = true;
      } else {
        this.canShow = false;
      }
    } else {
      if (this.$browser().version >= 304) {
        this.canShow = true;
      } else {
        this.canShow = false;
      }
    }
    if (this.$browser().ylxdsq || this.$browser().ulemax) {
      window.dsBridge &&
        window.dsBridge.call("setNativeTitle", {
          title: "接龙",
        });
    }
    let _this = this;
    if (_this.$browser().ylxdsq || _this.$browser().ulemax) {
      console.log("lowestOrgCode===", getCookie("lowestOrgCode"));
      _this.myQuery.orgId = getCookie("lowestOrgCode") || 27959;
      _this.helpQuery.orgId = getCookie("lowestOrgCode") || 27959;
      window.dsBridge.register("refreshList", function(s) {
        _this.refreshList();
      });
      window.dsBridge.call("registRefreshWebNotification", {
        JSViewWillAppearFunctionName: "refreshList",
      });
      _this.initList();
    } else {
      _this.myQuery.orgId = "27959";
      _this.helpQuery.orgId = "27959";
      _this.initList();
    }
  },
  computed: {
    computingTime() {
      return function(date) {
        let n = this.$moment().diff(date, "hour");
        if (n < 24) {
          if (n == 0 || n < 0) {
            return `1小时前`;
          } else {
            return `${n}小时前`;
          }
        } else if (n >= 24 && n < 48) {
          return `昨天`;
        } else if (n >= 48 && n < 72) {
          return `前天`;
        } else {
          return this.$moment(date).format("YYYY/MM/DD");
        }
      };
    },
  },
  methods: {
    // 创建接龙
    handleCreateGroup() {
      console.log(this.$browser());
      if (this.$browser().ios) {
        console.log("ios跳转");
        window.location.href = "objc:ulemobile://action&&UleTogetherBuyCreatVC&hasxib|0#isModification|0#logistics|2";
      } else if (this.$browser().android) {
        // window.location.href = "ulemobile://action&&ui.GroupPublishActivity";
        // window.location.href = "objc:ulemobile://action&&ui.GroupPublishActivity**hasxib::0!!isModification::0!!logistics::2";
        window.location.href = "ulemobile://action&&ui.GroupPublishActivity##hasxib::0**isModification::0**logistics::2";
      } else {
        this.$toast("请前往邮掌柜创建,谢谢!");
      }
    },
    handleGetId(item) {
      this.currentId = item.id;
      this.currentState = item.activityState;
      this.handleTogglePop(true, "bottom");
    },
    handleTogglePop(res) {
      this.isShowBottom = res;
    },
    // 更新我的发布
    refreashMyList() {
      console.log("有没有走这里");
      this.myList = [];
      this.myQuery.pageIndex = 1;
      this.myListFinished = false;
      this.myListStatus = 0;
      this.getMyList();
    },
    // 更新我帮卖的
    refreshHelpList(type) {
      if (type == "search") {
        if (this.helpQuery.keyword != "") {
          this.helpList = [];
          this.helpQuery.pageIndex = 1;
          this.helpFinished = false;
          this.helpListStatus = 0;
          this.getHelpList();
        }
      } else {
        this.helpList = [];
        this.helpQuery.pageIndex = 1;
        this.helpFinished = false;
        this.helpListStatus = 0;
        this.getHelpList();
      }
    },

    // 我发布的
    getMyList() {
      qrySelfChainsApi(this.myQuery)
        .then((res) => {
          if (res.returnCode == "0000" && res.data.result.length > 0) {
            this.myList = this.myList.concat(res.data.result);
            let myListTotalPages = Math.ceil(res.data.totalRecords / this.myQuery.pageSize);
            if (this.myQuery.pageIndex == myListTotalPages) {
              this.myListFinished = true;
            }
            this.myList.length > 0 ? (this.myListStatus = 1) : (this.myListStatus = 2);
            // 剩余条数
            this.myListSurplus = res.data.totalRecords - this.myList.length;
            console.log("res.data.totalRecords", res.data.totalRecords);
            console.log("this.myList.length", this.myList.length);
            console.log("剩余条数", this.myListSurplus);
            this.myList.forEach((item) => {
              // 活动描述
              if (item.activityDesc) {
                item.activityDescList = JSON.parse(item.activityDesc);
                // item.shareContent = item.activityDescList[0].desc || "";
              } else {
                item.activityDescList = [];
                // item.shareContent = "";
              }
              // 活动图片
              if (item.imgUrl) {
                item.imgList = item.imgUrl.split(",");
                if (item.imgList.length > 1) {
                  item.showMore = true;
                }
              } else {
                item.imgList = [];
                item.showMore = false;
              }
              item.lastTime = this.$moment(item.endTime)
                .diff(this.$moment())
                .toString();
              item.activityStartTime = this.$moment(item.startTime).format("YYYY/MM/DD");
              item.activityEndTime = this.$moment(item.endTime).format("YYYY/MM/DD");
              item.activityStateText = {
                0: "未发布",
                1: "未开始",
                2: "接龙中",
                3: "已结束",
              }[item.activityState];
              let currentDate = this.$moment(Date.now()).format("YYYYMMDDHHmmss"), // 当前时间
                endDate = this.$moment(item.endTime).format("YYYYMMDDHHmmss"); // 活动结束时间
              currentDate > endDate ? (item.isOver = true) : (item.isOver = false);
            });
            console.log("myListFinished", this.myListFinished);
            console.log("myListStatus", this.myListStatus);
          } else {
            this.myListStatus = 2;
            this.myListFinished = true;
          }
        })
        .catch((res) => {
          this.myListStatus = 2;
          this.myListFinished = true;
        });
    },
    // 我帮卖的
    getHelpList() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      qrySalesAndOrgChainsApi(this.helpQuery)
        .then((res) => {
          this.$toast.clear();
          this.helpLoading = false;
          this.helpFinished = false;
          if (res.returnCode === "0000") {
            if (res.data.result.length > 0) {
              this.helpListStatus = 1;
              let helpTotalPages = Math.ceil(res.data.totalRecords / this.helpQuery.pageSize);
              this.helpList = this.helpList.concat(res.data.result);
              this.helpList.forEach((item) => {
                // 活动描述
                if (item.activityDesc) {
                  item.activityDescList = JSON.parse(item.activityDesc);
                  // item.shareContent = item.activityDescList[0].desc || "";
                } else {
                  item.activityDescList = [];
                  // item.shareContent = "";
                }
                // 活动图片
                if (item.imgUrl) {
                  item.imgList = item.imgUrl.split(",");
                  if (item.imgList.length > 1) {
                    item.showMore = true;
                  }
                } else {
                  item.imgList = [];
                  item.showMore = false;
                }
                item.lastTime = this.$moment(item.endTime)
                  .diff(this.$moment())
                  .toString();
                item.activityStartTime = this.$moment(item.startTime).format("YYYY/MM/DD");
                item.activityEndTime = this.$moment(item.endTime).format("YYYY/MM/DD");
                item.activityStateText = {
                  0: "未发布",
                  1: "未开始",
                  2: "接龙中",
                  3: "已结束",
                }[item.activityState];
                let currentDate = this.$moment(Date.now()).format("YYYYMMDDHHmmss"), // 当前时间
                  endDate = this.$moment(item.endTime).format("YYYYMMDDHHmmss"); // 活动结束时间
                currentDate > endDate ? (item.isOver = true) : (item.isOver = false);
              });
              if (this.helpQuery.pageIndex == helpTotalPages) {
                this.helpFinished = true;
                this.helpFinishedText = "我已到达底部, 暂无其他数据啦~~";
              } else {
                this.helpFinished = false;
                this.helpQuery.pageIndex++;
              }
            } else {
              this.helpListStatus = 2;
              this.helpFinished = true;
            }
          } else {
            this.helpListStatus = 2;
            this.helpFinished = true;
          }
        })
        .catch((res) => {
          this.helpListStatus = 2;
          this.helpFinished = true;
        });
    },
    async initList() {
      console.log("my===initylsq", this.myQuery);
      console.log("help====initylsq", this.helpQuery);
      console.log("uleUrl()", uleUrl());
      this.isWhiteBySH = await this.getNameListBySH();
      this.myListFinished = false;
      this.helpFinished = false;
      this.myList = [];
      this.helpList = [];
      this.myQuery.pageIndex = 1;
      this.helpQuery.pageIndex = 1;
      // if (this.$route.query.showMy == 1) {
      this.getMyList();
      // this.showMy = true;
      // }
      this.getHelpList();
    },
    refreshList() {
      window.location.reload(true);
    },
    // 更新接龙状态
    getStateCanOver(index) {
      this.myList[index].activityState = 3;
      this.myList[index].activityStateText = "已结束";
    },
    // 点击获取更多列表
    handleGetMoreList() {
      this.myQuery.pageIndex++;
      this.getMyList();
    },
    // 跳转接龙详情
    handleToDetail(item) {
      console.log(item);
      console.log(this.$browser());
      // 未发布
      if (item.activityState == "0") {
        console.log("已发布");
        if (this.$browser().ios) {
          window.location.href = `objc:ulemobile://action&&WebDetailViewController:0&&key:https@@//h5.${uleUrl()}/yxd/community/ylsq/editGroup/${item.activityId}?status=1`;
        } else if (this.$browser().android) {
          window.location.href = `ulemobile://action&&ui.MyBusinessWebView##load_url::https://h5.${uleUrl()}/yxd/community/ylsq/editGroup/${item.activityId}?status=1`;
        } else {
          this.toNext(`/ylsq/editGroup/${item.activityId}?status=1`);
        }
      } else {
        console.log("已发布");
        this.handleWatch(item);
      }
    },
    // 点击查看收益
    handleWatch(item, status) {
      // this.toNext(`/ylsq/editGroup/${item.activityId}?isCheck=1`);
      if (this.$browser().ios) {
        window.location.href = `objc:ulemobile://action&&WebDetailViewController:0&&key:https@@//h5.${uleUrl()}/yxd/community/ylsq/editGroup/${item.activityId}?isCheck=1`;
      } else if (this.$browser().android) {
        window.location.href = `ulemobile://action&&ui.MyBusinessWebView##load_url::https://h5.${uleUrl()}/yxd/community/ylsq/editGroup/${item.activityId}?isCheck=1`;
      } else {
        this.toNext(`/ylsq/editGroup/${item.activityId}?isCheck=1`);
      }
    },
    // tab点击
    handleChangeNav(id) {
      console.log("tabActive===123", this.tabActive);
      if (this.tabActive == id) return false;
      this.helpListStatus = 0;
      this.shareListStatus = 0;
      this.tabActive = id;
      if (this.tabActive == 1) {
        this.initList();
      } else {
        this.shareList = [];
        this.getShareList();
      }
    },
    // 已分享列表
    getShareList() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      myShareJielongActListApi(this.shareQuery)
        .then((res) => {
          this.$toast.clear();
          this.shareLoading = false;
          this.shareFinished = false;
          let actCodes = "",
            list = [];
          if (res.returnCode === "0000") {
            if (res.data.xcxList.length > 0) {
              this.shareListStatus = 1;
              let totalPages = Math.ceil(res.data.totalFound / this.shareQuery.pageSize);
              list = this.shareList.concat(res.data.xcxList);
              list.forEach((item) => {
                if (actCodes) {
                  actCodes += "," + item.activityId;
                } else {
                  actCodes = item.activityId;
                }
                item.shareImgUrl = item.shareImgUrl || "";
                if (item.imgUrl) {
                  item.imgList = item.imgUrl.split(",");
                } else {
                  item.imgList = [];
                }
                item.activityStartTime = this.$moment(item.startTime).format("YYYY/MM/DD");
                item.activityEndTime = this.$moment(item.endTime).format("YYYY/MM/DD");
                let currentDate = this.$moment(Date.now()).format("YYYYMMDDHHmmss"), // 当前时间
                  endDate = this.$moment(item.endTime).format("YYYYMMDDHHmmss"); // 活动结束时间
                currentDate > endDate ? (item.isOver = 1) : (item.isOver = 0);
              });
              if (this.shareQuery.startIndex == totalPages) {
                this.shareFinished = true;
                this.shareFinishedText = "我已到达底部, 暂无其他数据啦~~";
              } else {
                this.shareFinished = false;
                this.shareQuery.startIndex++;
              }
              console.log("actCodes====", actCodes);
              this.getOrderNumber(actCodes);
              this.initShareList(list);
            } else {
              this.shareListStatus = 2;
              this.shareFinished = true;
            }
          } else {
            this.shareListStatus = 2;
            this.shareFinished = true;
          }
        })
        .catch((res) => {
          this.shareListStatus = 2;
          this.shareFinished = true;
        });
    },
    // 获取订单数
    getOrderNumber(actCodes) {
      jieLongOrderStatApi({ actCodes, clientCallType: "h5" }).then((res) => {
        if (res.returnCode == "0000") {
          this.orderDataList = res.data || {};
        }
      });
    },
    handleDownWordClick(item) {
      this.downWord(item, this);
    },
    downWord: async (item, that) => {
      //导出订单明细
      let copyContentH5 = (content) => {
        var copyDom = document.createElement("div");
        copyDom.innerText = content;
        copyDom.style.position = "absolute";
        copyDom.style.top = "0px";
        copyDom.style.right = "-9999px";
        document.body.appendChild(copyDom);
        //创建选中范围
        var range = document.createRange();
        range.selectNode(copyDom);
        //移除剪切板中内容
        window.getSelection().removeAllRanges();
        //添加新的内容到剪切板
        window.getSelection().addRange(range);
        //复制
        var successful = document.execCommand("copy");
        copyDom.parentNode.removeChild(copyDom);
        try {
          if (successful) {
            that.$toast("复制成功，去浏览器打开");
          } else {
            that.$toast("复制失败");
          }
        } catch (err) {
          console.log("Oops , unable to copy!");
        }
      };
      await exportJieLongOrderApi({
        actCode: item.activityId,
        clientCallType: "H5",
      }).then((res) => {
        if (that.$browser().ios) {
          window.dsBridge.call("generalAction", {
            type: "8",
            ios_action: '{"urlScheme":"' + res.data + '"}',
            android_action: "",
            maxversion: "999&999",
            minversion: "100&100",
            needlogin: "false",
            logTitle: "",
          });
        } else {
          copyContentH5(res.data);
          window.location.href = res.data;
        }
      });
    },
    initShareList(items) {
      var that = this;
      if (items.length > 0) {
        items = items.sort(function(a, b) {
          if (a.isOver > b.isOver) {
            return 1;
          } else if (a.isOver < b.isOver) {
            return -1;
          }
          return 0;
        });
      }
      that.shareList = items;
      console.log(this);
    },
    // 上海白名单接口
    getNameListBySH() {
      return specificStaffApi().then((res) => {
        if (res.returnCode == "0000") {
          if (res.data) {
            if (res.data.specificStaff) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        }
      });
    },
  },
};
